<template>

    <div class="hidden lg:mt-20 lg:block">
      <div class="grid grid-cols-3 gap-x-8" role="tablist" aria-orientation="horizontal">
        <div class="relative" :class="{ 'opacity-60 hover:opacity-100': activeTab !== 1 }" @click="toggleTab(1)">
          <div class="w-9 rounded-lg" :class="{ 'bg-blue-600': activeTab === 1, 'bg-slate-500': activeTab !== 1 }">
            <svg aria-hidden="true" class="h-9 w-9" fill="none">
              <defs>
                <linearGradient id=":Rarella:" x1="11.5" y1="18" x2="36" y2="15.5" gradientUnits="userSpaceOnUse">
                  <stop offset=".194" stop-color="#fff"></stop>
                  <stop offset="1" stop-color="#6692F1"></stop>
                </linearGradient>
              </defs>
              <path d="m30 15-4 5-4-11-4 18-4-11-4 7-4-5" stroke="url(#:Rarella:)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </div>
          <h3 class="mt-6 font-medium " :class="{ 'text-blue-600': activeTab === 1, 'text-slate-600': activeTab !== 1 }">
            <button class="ui-not-focus-visible:outline-none" role="tab" type="button" aria-selected="true" tabindex="0" data-headlessui-state="selected" aria-controls="headlessui-tabs-panel-:Rbbella:">
              <span class="absolute inset-0"></span>{{ I18N.website.homepage.features.secondary_features.heading_2 }}
            </button>
          </h3>
<!--          <p class="mt-2 font-display text-xl text-slate-900">Stay on top of things with always up-to-date reporting features.</p>-->
          <p class="mt-4 text-sm text-justify text-slate-600">{{ I18N.website.homepage.features.secondary_features.sub_heading_2 }}</p>
        </div>
        <div class="relative" :class="{ 'opacity-60 hover:opacity-100': activeTab !== 2 }" @click="toggleTab(2)">
          <div class="w-9 rounded-lg" :class="{ 'bg-blue-600': activeTab === 2, 'bg-slate-500': activeTab !== 2 }">
            <svg aria-hidden="true" class="h-9 w-9" fill="none">
              <path opacity=".5" d="M8 17a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-2Z" fill="#fff"></path>
              <path opacity=".3" d="M8 24a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-2Z" fill="#fff"></path>
              <path d="M8 10a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-2Z" fill="#fff"></path>
            </svg>
          </div>
          <h3 class="mt-6 font-medium" :class="{ 'text-blue-600': activeTab === 2, 'text-slate-600': activeTab !== 2 }">
            <button class="ui-not-focus-visible:outline-none" id="headlessui-tabs-tab-:Rkrella:" role="tab" type="button" aria-selected="false" tabindex="-1" data-headlessui-state="" aria-controls="headlessui-tabs-panel-:Rjbella:">
              <span class="absolute inset-0"></span>{{ I18N.website.homepage.features.secondary_features.heading_4 }}
            </button>
          </h3>
<!--          <p class="mt-2 font-display text-xl text-slate-900">Never lose track of what’s in stock with accurate inventory tracking.</p>-->
          <p class="mt-4 text-sm text-justify text-slate-600"> {{ I18N.website.homepage.features.secondary_features.sub_heading_4 }}</p>
        </div>
        <div class="relative" :class="{ 'opacity-60 hover:opacity-100': activeTab !== 3 }" @click="toggleTab(3)">
          <div class="w-9 rounded-lg" :class="{ 'bg-blue-600': activeTab === 3, 'bg-slate-500': activeTab !== 3 }">
            <svg aria-hidden="true" class="h-9 w-9" fill="none">
              <path opacity=".5" d="M25.778 25.778c.39.39 1.027.393 1.384-.028A11.952 11.952 0 0 0 30 18c0-6.627-5.373-12-12-12S6 11.373 6 18c0 2.954 1.067 5.659 2.838 7.75.357.421.993.419 1.384.028.39-.39.386-1.02.036-1.448A9.959 9.959 0 0 1 8 18c0-5.523 4.477-10 10-10s10 4.477 10 10a9.959 9.959 0 0 1-2.258 6.33c-.35.427-.354 1.058.036 1.448Z" fill="#fff"></path>
              <path d="M12 28.395V28a6 6 0 0 1 12 0v.395A11.945 11.945 0 0 1 18 30c-2.186 0-4.235-.584-6-1.605ZM21 16.5c0-1.933-.5-3.5-3-3.5s-3 1.567-3 3.5 1.343 3.5 3 3.5 3-1.567 3-3.5Z" fill="#fff"></path>
            </svg>
          </div>
          <h3 class="mt-6 font-medium" :class="{ 'text-blue-600': activeTab === 3, 'text-slate-600': activeTab !== 3 }">
            <button class="ui-not-focus-visible:outline-none" id="headlessui-tabs-tab-:Rmrella:" role="tab" type="button" aria-selected="false" tabindex="-1" data-headlessui-state="" aria-controls="headlessui-tabs-panel-:Rrbella:">
              <span class="absolute inset-0"></span>{{ I18N.website.homepage.features.secondary_features.heading_3 }}
            </button>
          </h3>
<!--          <p class="mt-2 font-display text-xl text-slate-900">Organize all of your contacts, service providers, and invoices in one place.</p>-->
          <p class="mt-4 text-sm text-justify text-slate-600">{{ I18N.website.homepage.features.secondary_features.sub_heading_3}}</p>
        </div>
      </div>
      <div class="relative mt-20 overflow-hidden rounded-3xl bg-slate-200 px-14 py-16 xl:px-16">
        <div class="-mx-5 flex">
          <div class="px-5 transition duration-500 ease-in-out ui-not-focus-visible:outline-none" :class="{ 'opacity-50': activeTab !== 1 }" :style="'transform: translateX(-' + getTranslateX + '%);'"  role="tabpanel">
            <div class="w-[52.75rem] overflow-hidden rounded-xl bg-white shadow-lg shadow-slate-900/5 ring-1 ring-slate-500/10">
              <img alt="" loading="lazy" width="1688" height="856" decoding="async" data-nimg="1" class="w-full" style="color:transparent" sizes="52.75rem"  src="/images/website/availabilities.png">
            </div>
          </div>
          <div class="px-5 transition duration-500 ease-in-out ui-not-focus-visible:outline-none"  :class="{ 'opacity-50': activeTab !== 2 }" :style="'transform: translateX(-' + getTranslateX + '%);'" role="tabpanel">
            <div class="w-[52.75rem] overflow-hidden rounded-xl bg-white shadow-lg shadow-slate-900/5 ring-1 ring-slate-500/10">
              <img alt="" loading="lazy" width="1688" height="856" decoding="async" data-nimg="1" class="w-full" style="color:transparent" sizes="52.75rem" src="/images/website/holiday.png">
            </div>
          </div>
          <div class="px-5 transition duration-500 ease-in-out ui-not-focus-visible:outline-none"  :class="{ 'opacity-50': activeTab !== 3 }" :style="'transform: translateX(-' + getTranslateX + '%);'" role="tabpanel">
            <div class="w-[52.75rem] overflow-hidden rounded-xl bg-white shadow-lg shadow-slate-900/5 ring-1 ring-slate-500/10">
              <img alt="" loading="lazy" width="1688" height="856" decoding="async" data-nimg="1" class="w-full" style="color:transparent" sizes="52.75rem" src="/images/website/notifications.png">
            </div>
          </div>
        </div>
      </div>
    </div>

  
</template>

<script>
import Constants from "controllers/vue_components/mixins/constants"
export default {
    name: 'HomeSecondaryFeatures',
    mixins: [Constants],

    data() {
        return {
            activeTab: 1,
        };
    },

    methods: {
        toggleTab(tabNumber) {
            this.activeTab = tabNumber;
        }
    },
    computed: {
        getTranslateX() {
            // Calculate translateX based on activeTab
            return (this.activeTab - 1) * 100;
        },
    },
    created() {

    }
}
</script>
